import { motion, useMotionValue, useSpring, useTransform, useScroll } from "framer-motion";
import { APPS } from "@/lib/content";
import { PhoneFrame } from "./PhoneFrame";

export const HeroPhones = () => {
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const rotY = useSpring(useTransform(mx, [-0.5, 0.5], [-14, 14]), { stiffness: 80, damping: 18 });
  const rotX = useSpring(useTransform(my, [-0.5, 0.5], [10, -10]), { stiffness: 80, damping: 18 });
  const { scrollY } = useScroll();
  const backY = useTransform(scrollY, [0, 700], [0, -90]);
  const frontY = useTransform(scrollY, [0, 700], [0, 60]);

  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    mx.set((e.clientX - r.left) / r.width - 0.5);
    my.set((e.clientY - r.top) / r.height - 0.5);
  };
  const reset = () => { mx.set(0); my.set(0); };

  return (
    <div data-testid="hero-phones" onMouseMove={onMove} onMouseLeave={reset} className="relative mx-auto h-[440px] w-full max-w-[520px] [perspective:1400px] sm:h-[560px]">
      <div className="absolute left-1/2 top-1/2 h-[70%] w-[70%] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#0D6EFD]/30 blur-[90px]" />
      <motion.div style={{ rotateX: rotX, rotateY: rotY, transformStyle: "preserve-3d" }} className="relative h-full w-full">
        <motion.div
          style={{ y: backY, z: -60 }}
          initial={{ opacity: 0, x: 60, rotate: 8 }}
          animate={{ opacity: 1, x: 0, rotate: 6 }}
          transition={{ duration: 1.3, delay: 0.5, ease: [0.16, 1, 0.3, 1] }}
          className="absolute right-0 top-4 w-[44%] sm:right-6"
        >
          <PhoneFrame src={APPS[1].image} alt="Trivia Pop app screen" />
        </motion.div>
        <motion.div
          style={{ y: frontY, z: 60 }}
          initial={{ opacity: 0, y: 80, rotate: -10 }}
          animate={{ opacity: 1, y: 0, rotate: -6 }}
          transition={{ duration: 1.3, delay: 0.35, ease: [0.16, 1, 0.3, 1] }}
          className="absolute bottom-0 left-4 w-[46%] sm:left-8"
        >
          <PhoneFrame src={APPS[0].image} alt="Trailer API app screen" />
        </motion.div>
      </motion.div>
    </div>
  );
};
